var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"success"},[_c('section',{staticClass:"section"},[_c('Breadcrumb',{attrs:{"step":"3"}})],1),_c('section',{staticClass:"wrapper section"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }